import tempIconData from '../../styles/iconjar/iconjar.json';

const groupIconCache: Record<string, string> = {};

export const createGroupIconCacheKey = (color: string, number: number, borderColor: string): string => {
  return `${color}|${number}|${borderColor}`;
};

export const cleanupGroupIconCache = (): void => {
  Object.values(groupIconCache).forEach((url) => {
    URL.revokeObjectURL(url);
  });
  Object.keys(groupIconCache).forEach((key) => {
    delete groupIconCache[key];
  });
};

export const getGroupIconUrl = (color: string, number: number, borderColor: string): string => {
  const cacheKey = createGroupIconCacheKey(color, number, borderColor);

  if (groupIconCache[cacheKey]) {
    return groupIconCache[cacheKey];
  }

  const textLength = number.toString().length;
  const pillWidth = Math.max(30, 20 + textLength * 7);
  const pillHeight = 20;
  const pillHeightHalf = pillHeight / 2;

  const svgSize = Math.max(36, pillWidth + 6);
  const pillPosition = (svgSize - pillWidth) / 2;
  const svgContent = `
    <svg xmlns="http://www.w3.org/2000/svg" 
      width="${svgSize}" 
      height="${svgSize}" 
      viewBox="0 0 ${svgSize} ${svgSize}"
      shape-rendering="geometricPrecision"
      text-rendering="optimizeLegibility">
      <g transform="translate(${pillPosition}, ${pillPosition})">
        <rect
          x="0"
          y="0"
          width="${pillWidth}"
          height="${pillHeight}"
          rx="${pillHeightHalf}"
          ry="${pillHeightHalf}"
          fill="${color}"
          stroke="${borderColor}"
          stroke-width="2"
        />
        <text
          x="${pillWidth / 2}"
          y="${pillHeightHalf + 1}"
          font-family="Arial"
          font-size="10"
          fill="white"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          ${number}
        </text>
      </g>
    </svg>
  `;

  const base64Svg = btoa(decodeURIComponent(encodeURIComponent(svgContent)));
  const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;
  groupIconCache[cacheKey] = dataUrl;

  return dataUrl;
};

export const getIconAssetUrl = (iconName: string, getAssetUrl: (assetName: string) => string): string => {
  const iconData = tempIconData[iconName as keyof typeof tempIconData];
  if (!iconData || !('file' in iconData)) {
    return '';
  }
  return getAssetUrl(iconData.file);
};
